<template>
  <Loader v-if="loading && editMode"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <div class="form countryForm custom_card fadeIn" v-else>
      <form @submit.prevent="validateCreateForm">
        <div class="row">
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label">
                {{ $t("forms.labels.permission_categories") }}
              </label>
              <multiselect
                v-model="data.permission_category_id"
                :options="permission_categories"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>

          <div
            class="permissions_row mb-2"
            v-for="(row, index) in data.permission_row"
            :key="index"
          >
            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-6">
                    <v-checkbox
                      title="الظهور في sidebar"
                      color="success"
                      v-model="row.is_side_show"
                      :label="$t('forms.labels.is_side_show')"
                    ></v-checkbox>
                  </div>
                  <div class="col-md-6">
                    <v-checkbox
                      title="التحكم في التفعيل والحظر ...الخ"
                      color="success"
                      v-model="row.is_control_permissions"
                      :label="$t('forms.labels.is_control_permissions')"
                    ></v-checkbox>
                  </div>
                  <div class="col-12"></div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        @keypress="isArabic"
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="row.title_ar"
                      />
                      <label for="name_input" class="form-label">
                        {{ $t("forms.labels.title_ar") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        @keypress="isEnglish"
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="row.title_en"
                      />
                      <label for="name_input" class="form-label">
                        {{ $t("forms.labels.title_en") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <label class="form-label">
                        {{ $t("forms.labels.permission_url") }}
                      </label>
                      <multiselect
                        v-model="row.permission_route"
                        :options="allRoutes"
                        label="name"
                        track-by="id"
                        placeholder=" "
                        :searchable="true"
                        :allow-empty="true"
                        :show-labels="false"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="col-lg-6 py-0">
                    <div class="input_wrapper top_label">
                      <input
                        type="text"
                        class="form-control"
                        @input="helper_checkIfInputIsEmpty"
                        v-model.trim="row.icon"
                      />
                      <label for="name_input" class="form-label">
                        {{ $t("forms.labels.icon") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 d-flex" v-if="!id">
                <div class="d-flex justify-center align-center mx-1">
                  <span class="append" @click="appendRow()">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </div>
                <div
                  class="d-flex justify-center align-center mx-1"
                  v-if="data.permission_row.length > 1"
                >
                  <span class="append" @click="deleteRow(index)">
                    <i class="fas fa-minus-circle"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
        <!-- <base-button type="submit" @click="submit" class="center"></base-button> -->
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],

  data() {
    return {
      noData: false,
      loading: false,
      btnIsLoading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.permissions.title"),
          disabled: false,
          href: "/permissions/show-all",
        },
        {
          text: this.$t("breadcrumb.permissions.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading

      // ========== create_data
      data: {
        permission_category_id: null,
        permission_row: [
          {
            title_ar: null,
            title_en: null,
            icon: null,
            permission_route: null,
            is_side_show: true,
            is_control_permissions: true,
          },
        ],
      },

      permission_categories: [],
      selectedRoute: [],
      allRoutes: [
        {
          key: "sliders",
          id: 1,
          name: "عرض كل الاسليدر",
          frontend_url: "sliders/show-all",
          backend_url: "slider/.GET",
        },
        {
          key: "sliders",
          id: 2,
          name: "اضافة سليدر",
          frontend_url: "sliders/add",
          backend_url: "slider/.POST",
        },
        {
          key: "sliders",
          id: 3,
          name: "تعديل سليدر",
          frontend_url: "sliders/edit/",
          backend_url: "slider/*/.PUT",
        },
        {
          key: "clients",
          id: 4,
          name: "عرض كل العملاء",
          frontend_url: "clients/show-all",
          backend_url: "client/.GET",
        },
        {
          key: "clients",
          id: 5,
          name: "اضافة عميل",
          frontend_url: "clients/add",
          backend_url: "client/.POST",
        },
        {
          key: "clients",
          id: 6,
          name: "تعديل عميل",
          frontend_url: "clients/edit/",
          backend_url: "client/*/.PUT",
        },

        {
          key: "clients",
          id: 7,
          name: "عرض عميل",
          frontend_url: "clients/show/",
          backend_url: "client/*/.GET",
        },
        {
          key: "clients",
          id: 8,
          name: "حذف عميل",
          frontend_url: "clients/delete",
          backend_url: "client/*/.DELETE",
        },
        {
          key: "drivers",
          id: 9,
          name: "عرض كل السائقين",
          frontend_url: "drivers/show-all",
          backend_url: "driver/.GET",
        },
        {
          key: "drivers",
          id: 10,
          name: "اضافة سائق",
          frontend_url: "drivers/add",
          backend_url: "driver/.POST",
        },
        {
          key: "drivers",
          id: 11,
          name: "تعديل سائق",
          frontend_url: "drivers/edit/",
          backend_url: "driver/*/.PUT",
        },

        {
          key: "drivers",
          id: 12,
          name: "عرض سائق",
          frontend_url: "drivers/show/",
          backend_url: "driver/*/.GET",
        },
        {
          key: "drivers",
          id: 13,
          name: "حذف سائق",
          frontend_url: "drivers/delete",
          backend_url: "driver/*/.DELETE",
        },
        {
          key: "menus",
          id: 14,
          name: "عرض كل القوائم",
          frontend_url: "menus/show-all",
          backend_url: "menu/.GET",
        },
        {
          key: "menus",
          id: 15,
          name: "اضافة قائمة",
          frontend_url: "menus/add",
          backend_url: "menu/.POST",
        },
        {
          key: "menus",
          id: 16,
          name: "تعديل القائمة",
          frontend_url: "menus/edit/",
          backend_url: "menu/*/.PUT",
        },

        // {
        //   key: "menus",
        //   id: 17,
        //   name: "عرض سائق",
        //   frontend_url: "menus/show/",
        //   backend_url: "menu/*/.GET",
        // },
        {
          key: "menus",
          id: 17,
          name: "حذف القائمة",
          frontend_url: "menus/delete",
          backend_url: "menu/*/.DELETE",
        },
        {
          key: "store_category",
          id: 18,
          name: "عرض  تصنيفات المتاجر",
          frontend_url: "categories/show-all",
          backend_url: "store_category/.GET",
        },
        {
          key: "store_category",
          id: 19,
          name: "اضافة تصنيف متجر",
          frontend_url: "categories/add",
          backend_url: "store_category/.POST",
        },
        {
          key: "store_category",
          id: 20,
          name: "تعديل تصنيف المتجر",
          frontend_url: "categories/edit/",
          backend_url: "store_category/*/.PUT",
        },

        {
          key: "store_category",
          id: 21,
          name: "حذف تصنيف المتجر",
          frontend_url: "categories/delete",
          backend_url: "store_category/*/.DELETE",
        },
        {
          key: "restaurant_specialty",
          id: 22,
          name: "عرض  تصنيفات المطاعم",
          frontend_url: "restaurant_specialty/show-all",
          backend_url: "restaurant_specialty/.GET",
        },
        {
          key: "restaurant_specialty",
          id: 23,
          name: "اضافة تصنيف مطعم",
          frontend_url: "restaurant_specialty/add",
          backend_url: "restaurant_specialty/.POST",
        },
        {
          key: "restaurant_specialty",
          id: 24,
          name: "تعديل تصنيف مطعم",
          frontend_url: "restaurant_specialty/edit/",
          backend_url: "restaurant_specialty/*/.PUT",
        },
        {
          key: "restaurant_specialty",
          id: 25,
          name: "حذف تصنيف مطعم",
          frontend_url: "restaurant_specialty/delete",
          backend_url: "restaurant_specialty/*/.DELETE",
        },
        {
          key: "stores",
          id: 26,
          name: "عرض كل المتاجر",
          frontend_url: "stores/show-all",
          backend_url: "store/.GET",
        },
        {
          key: "stores",
          id: 27,
          name: "اضافة متجر",
          frontend_url: "stores/add",
          backend_url: "store/.POST",
        },
        {
          key: "stores",
          id: 28,
          name: "تعديل المتجر",
          frontend_url: "stores/edit/",
          backend_url: "store/*/.PUT",
        },
        {
          key: "stores",
          id: 29,
          name: "عرض المتجر",
          frontend_url: "stores/show/",
          backend_url: "store/*/.GET",
        },
        {
          key: "stores",
          id: 30,
          name: "حذف المتجر",
          frontend_url: "stores/delete",
          backend_url: "store/*/.DELETE",
        },
        {
          key: "products",
          id: 31,
          name: "عرض كل المنتجات",
          frontend_url: "products/show-all",
          backend_url: "meal/.GET",
        },

        {
          key: "products",
          id: 32,
          name: "عرض منتج",
          frontend_url: "products/show/",
          backend_url: "meal/*/.GET",
        },
        {
          key: "products",
          id: 33,
          name: "حذف منتج",
          frontend_url: "meal/delete",
          backend_url: "meal/*/.DELETE",
        },
        {
          key: "companies",
          id: 34,
          name: "عرض  شركات المناديب",
          frontend_url: "companies/show-all",
          backend_url: "company/.GET",
        },

        {
          key: "companies",
          id: 35,
          name: "عرض شركة مندوب",
          frontend_url: "companies/show/",
          backend_url: "company/*/.GET",
        },
        {
          key: "companies",
          id: 36,
          name: "إضافة شركة مندوب",
          frontend_url: "companies/add",
          backend_url: "company/*/.POST",
        },
        {
          key: "companies",
          id: 37,
          name: "تعديل شركة المندوب",
          frontend_url: "companies/edit/",
          backend_url: "company/*/.PUT",
        },

        {
          key: "companies",
          id: 38,
          name: "عرض شركة المندوب",
          frontend_url: "companies/show/",
          backend_url: "company/*/.GET",
        },
        {
          key: "companies",
          id: 39,
          name: "حذف شركة المندوب",
          frontend_url: "companies/delete",
          backend_url: "company/*/.DELETE",
        },
        {
          key: "google_place",
          id: 40,
          name: "عرض متاجر جوجل",
          frontend_url: "googlePlace/show-all/",
          backend_url: "get_places_paginate/*/.GET",
        },
        {
          key: "google_place",
          id: 41,
          name: "عرض متجر جوجل",
          frontend_url: "googlePlace/show/",
          backend_url: "show_place/*/.GET",
        },
        {
          key: "delivery_orders",
          id: 42,
          name: "عرض  طلبات التوصيلات",
          frontend_url: "delivery_orders/show-all",
          backend_url: "order/.GET",
        },

        {
          key: "delivery_orders",
          id: 43,
          name: "عرض طلب توصيل",
          frontend_url: "delivery_orders/show/",
          backend_url: "order/*/.GET",
        },
        {
          key: "package_order",
          id: 44,
          name: "عرض  طلبات الطرود",
          frontend_url: "package_order/show-all",
          backend_url: "package_order/.GET",
        },

        {
          key: "packages_orders",
          id: 45,
          name: "عرض طلب طرد",
          frontend_url: "package_order/show/",
          backend_url: "package_order/*/.GET",
        },
        {
          key: "transactions",
          id: 46,
          name: "عرض  طلبات السحب",
          frontend_url: "all-transactions",
          backend_url: "cashout_requests/.GET",
        },

        // {
        //   key: "withdraw",
        //   id: 10,
        //   name: "طلبات السحب",
        //   frontend_url: "withdraw/show-all",
        //   backend_url: "cashout-requests/.GET",
        // },
        // {
        //   key: "locked-users",
        //   id: 11,
        //   name: "الحسابات المحجوبة",
        //   frontend_url: "locked-users",
        //   backend_url: "locked-user/.GET",
        // },
        {
          id: 47,
          key: "withdraw",
          name: "(قبول رفض)/ سحب",
          frontend_url: "withdrawl/accept",
          backend_url: "cashout-requests/*/accept/.POST`",
        },
        {
          key: "offers",
          id: 48,
          name: "عرض كل العروض",
          frontend_url: "offers/show-all",
          backend_url: "offer/.GET",
        },
        {
          key: "offers",
          id: 49,
          name: "اضافة عرض",
          frontend_url: "offers/add",
          backend_url: "offer/.POST",
        },
        {
          key: "offers",
          id: 50,
          name: "تعديل عرض",
          frontend_url: "offers/edit/",
          backend_url: "offer/*/.PUT",
        },

        {
          key: "offers",
          id: 51,
          name: "عرض عرض",
          frontend_url: "offers/show/",
          backend_url: "offer/*/.GET",
        },
        {
          key: "offers",
          id: 52,
          name: "حذف عرض",
          frontend_url: "offers/delete",
          backend_url: "offer/*/.DELETE",
        },
        {
          key: "coupons",
          id: 53,
          name: "عرض كل الكوبونات",
          frontend_url: "coupons/show-all",
          backend_url: "coupon/.GET",
        },
        {
          key: "coupons",
          id: 54,
          name: "اضافة كوبون",
          frontend_url: "coupons/add",
          backend_url: "coupon/.POST",
        },
        {
          key: "coupons",
          id: 55,
          name: "تعديل كوبون",
          frontend_url: "coupons/edit/",
          backend_url: "coupon/*/.PUT",
        },
        {
          key: "coupons",
          id: 56,
          name: "عرض كوبون",
          frontend_url: "coupons/show/",
          backend_url: "coupon/*/.GET",
        },
        {
          key: "coupons",
          id: 57,
          name: "حذف كوبون",
          frontend_url: "coupons/delete",
          backend_url: "coupon/*/.DELETE",
        },
        {
          key: "chat",
          id: 58,
          name: "اللايف شات للمستخدمين",
          frontend_url: "chats/client",
          backend_url: "support_chats_client/.GET",
        },
        {
          key: "chat",
          id: 145,
          name: "اللايف شات للسائقين",
          frontend_url: "chats/driver",
          backend_url: "support_chats_driver/.GET",
        },
        {
          key: "chat",
          id: 146,
          name: "اللايف شات للمتاجر",
          frontend_url: "chats/resturant",
          backend_url: "support_chats_restaurant/.GET",
        },
        {
          key: "google_place",
          id: 59,
          name: "عرض كل المتاجر",
          frontend_url: "googlePlace/show-all",
          backend_url: "get_places_paginate/*/.GET",
        },
        {
          key: "google_place",
          id: 59,
          name: " اضافة متجر",
          frontend_url: "googlePlace/add",
          backend_url: "place/store/*/.POST",
        },
        {
          key: "google_place",
          id: 59,
          name: "تعديل متجر",
          frontend_url: "googlePlace/edit",
          backend_url: "place/store/*/.PUT",
        },
        {
          key: "google_place",
          id: 60,
          name: "البحث عن مطعم",
          frontend_url: "googlePlace/searchResturants",
          backend_url: "getPlaces/*/.PUT",
        },
        {
          key: "bonus",
          id: 61,
          name: "عرض كل المكافئات",
          frontend_url: "bonus/show-all",
          backend_url: "bonus/.GET",
        },
        {
          key: "bonus",
          id: 62,
          name: "اضافة مكافئة",
          frontend_url: "bonus/add",
          backend_url: "bonus/.POST",
        },
        {
          key: "bonus",
          id: 63,
          name: "تعديل مكافئة",
          frontend_url: "bonus/edit/",
          backend_url: "bonus/*/.PUT",
        },
        {
          key: "bonus",
          id: 64,
          name: "عرض مكافئة",
          frontend_url: "bonus/show/",
          backend_url: "bonus/*/.GET",
        },
        {
          key: "bonus",
          id: 65,
          name: "حذف مكافئة",
          frontend_url: "bonus/delete",
          backend_url: "bonus/*/.DELETE",
        },
        {
          key: "notifications",
          id: 66,
          name: "عرض كل الاشعارات",
          frontend_url: "notifications/all-notifications",
          backend_url: "notification/.GET",
        },
        {
          key: "notifications",
          id: 67,
          name: "اضافة اشعار",
          frontend_url: "notifications/add",
          backend_url: "notification/.POST",
        },
        {
          key: "notifications",
          id: 68,
          name: "عرض اشعار",
          frontend_url: "notifications/show/",
          backend_url: "notification/*/.GET",
        },
        {
          key: "notifications",
          id: 69,
          name: "حذف اشعار",
          frontend_url: "notifications/delete",
          backend_url: "notification/*/.DELETE",
        },
        {
          key: "logs",
          id: 70,
          name: "عرض كل العمليات",
          frontend_url: "logs/show-all",
          backend_url: "logs/.GET",
        },
        {
          key: "logs",
          id: 71,
          name: "حذف عملية",
          frontend_url: "logs/delete",
          backend_url: "logs/*/.DELETE",
        },
        {
          key: "cancel_reason",
          id: 72,
          name: "عرض كل الاسباب",
          frontend_url: "cancel_reasons/show-all",
          backend_url: "cancel_reason/.GET",
        },
        {
          key: "cancel_reason",
          id: 73,
          name: "اضافة سبب",
          frontend_url: "cancel_reasons/add",
          backend_url: "cancel_reason/.POST",
        },
        {
          key: "cancel_reason",
          id: 74,
          name: "تعديل سبب",
          frontend_url: "cancel_reasons/edit/",
          backend_url: "cancel_reason/*/.PUT",
        },
        {
          key: "cancel_reason",
          id: 75,
          name: "عرض سبب",
          frontend_url: "cancel_reasons/show/",
          backend_url: "cancel_reason/*/.GET",
        },
        {
          key: "cancel_reason",
          id: 76,
          name: "حذف سبب",
          frontend_url: "cancel_reasons/delete",
          backend_url: "cancel_reason/*/.DELETE",
        },
        {
          key: "setting",
          id: 77,
          name: "الاعدادات العامة",
          frontend_url: "settings",
          backend_url: "setting/.GET",
        },
        {
          key: "report_delivery",
          id: 78,
          name: "التقارير المالية",
          frontend_url: "financial_reports",
          backend_url: "report_delivery/.GET",
        },
        {
          key: "nationality",
          id: 79,
          name: "عرض كل الجنسيات",
          frontend_url: "nationality/show-all",
          backend_url: "nationality/.GET",
        },
        {
          key: "nationality",
          id: 80,
          name: "اضافة جنسية",
          frontend_url: "nationality/add",
          backend_url: "nationality/.POST",
        },
        {
          key: "nationality",
          id: 81,
          name: "تعديل جنسية",
          frontend_url: "nationality/edit/",
          backend_url: "nationality/*/.PUT",
        },
        {
          key: "nationality",
          id: 82,
          name: "عرض جنسية",
          frontend_url: "nationality/show/",
          backend_url: "nationality/*/.GET",
        },
        {
          key: "nationality",
          id: 83,
          name: "حذف جنسية",
          frontend_url: "nationality/delete/",
          backend_url: "nationality/*/.DELETE",
        },
        {
          key: "country",
          id: 84,
          name: "عرض كل الدول",
          frontend_url: "countries/show-all",
          backend_url: "country/.GET",
        },
        {
          key: "country",
          id: 85,
          name: "اضافة دولة",
          frontend_url: "countries/add",
          backend_url: "country/.POST",
        },
        {
          key: "country",
          id: 86,
          name: "تعديل دولة",
          frontend_url: "countries/edit/",
          backend_url: "country/*/.PUT",
        },
        {
          key: "country",
          id: 87,
          name: "عرض دولة",
          frontend_url: "countries/show/",
          backend_url: "country/*/.GET",
        },
        {
          key: "country",
          id: 88,
          name: "حذف دولة",
          frontend_url: "countries/delete/",
          backend_url: "country/*/.DELETE",
        },
        {
          key: "city",
          id: 89,
          name: "عرض كل المدن",
          frontend_url: "cities/show-all",
          backend_url: "city/.GET",
        },
        {
          key: "city",
          id: 90,
          name: "اضافة مدينة",
          frontend_url: "cities/add",
          backend_url: "city/.POST",
        },
        {
          key: "city",
          id: 91,
          name: "تعديل مدينة",
          frontend_url: "cities/edit/",
          backend_url: "city/*/.PUT",
        },
        {
          key: "city",
          id: 92,
          name: "عرض مدينة",
          frontend_url: "cities/show/",
          backend_url: "city/*/.GET",
        },
        {
          key: "city",
          id: 93,
          name: "حذف مدينة",
          frontend_url: "cities/delete/",
          backend_url: "city/*/.DELETE",
        },
        {
          key: "region",
          id: 94,
          name: "عرض كل المناطق",
          frontend_url: "regions/show-all",
          backend_url: "region/.GET",
        },
        {
          key: "region",
          id: 95,
          name: "اضافة منطقة",
          frontend_url: "regions/add",
          backend_url: "region/.POST",
        },
        {
          key: "region",
          id: 96,
          name: "تعديل منطقة",
          frontend_url: "regions/edit/",
          backend_url: "region/*/.PUT",
        },
        {
          key: "region",
          id: 97,
          name: "عرض منطقة",
          frontend_url: "regions/show/",
          backend_url: "region/*/.GET",
        },
        {
          key: "region",
          id: 98,
          name: "حذف منطقة",
          frontend_url: "regions/delete/",
          backend_url: "region/*/.DELETE",
        },
        {
          key: "district",
          id: 99,
          name: "عرض كل الاحياء",
          frontend_url: "districts/show-all",
          backend_url: "district/.GET",
        },
        {
          key: "district",
          id: 100,
          name: "اضافة حي",
          frontend_url: "districts/add",
          backend_url: "district/.POST",
        },
        {
          key: "district",
          id: 101,
          name: "تعديل حي",
          frontend_url: "districts/edit/",
          backend_url: "district/*/.PUT",
        },
        {
          key: "district",
          id: 102,
          name: "عرض حي",
          frontend_url: "districts/show/",
          backend_url: "district/*/.GET",
        },
        {
          key: "district",
          id: 103,
          name: "حذف حي",
          frontend_url: "districts/delete/",
          backend_url: "district/*/.DELETE",
        },
        {
          key: "driver_referral_code",
          id: 104,
          name: "مشاركة التطبيقات",
          frontend_url: "drivers/driver_referral_code",
          backend_url: "driver/driver_referral_code/.GET",
        },
        {
          key: "drivers_tracking",
          id: 104,
          name: "تتبع الطلبات",
          frontend_url: "drivers/drivers_tracking",
          backend_url: "orders/.GET",
        },
        {
          key: "permission_label",
          id: 105,
          name: "عرض كل اقسام الصلاحيات الرئيسية",
          frontend_url: "permission-labels/show-all",
          backend_url: "permission_label/.GET",
        },
        {
          key: "permission_label",
          id: 106,
          name: "اضافة قسم الصلاحية الرئيسي",
          frontend_url: "permission-labels/add",
          backend_url: "permission_label/.POST",
        },
        {
          key: "permission_label",
          id: 107,
          name: "تعديل قسم الصلاحية الرئيسي",
          frontend_url: "permission-labels/edit/",
          backend_url: "permission_label/*/.PUT",
        },
        {
          key: "permission_label",
          id: 108,
          name: "عرض قسم صلاحية",
          frontend_url: "permission-labels/show/",
          backend_url: "permission_label/*/.GET",
        },
        {
          key: "permission_label",
          id: 109,
          name: "حذف قسم الصلاحية الرئيسي",
          frontend_url: "permission-labels/delete/",
          backend_url: "permission_label/*/.DELETE",
        },
        {
          key: "permission_category",
          id: 110,
          name: "عرض كل اقسام الصلاحيات",
          frontend_url: "permission-categories/show-all",
          backend_url: "permission_label/.GET",
        },
        {
          key: "permission_category",
          id: 111,
          name: "اضافة قسم صلاحية",
          frontend_url: "permission-categories/add",
          backend_url: "permission_category/.POST",
        },
        {
          key: "permission_category",
          id: 112,
          name: "تعديل قسم صلاحية",
          frontend_url: "permission-categories/edit/",
          backend_url: "permission_category/*/.PUT",
        },
        {
          key: "permission_category",
          id: 113,
          name: "عرض قسم صلاحية",
          frontend_url: "permission-categories/show/",
          backend_url: "permission_category/*/.GET",
        },
        {
          key: "permission_category",
          id: 114,
          name: "حذف قسم صلاحية",
          frontend_url: "permission-categories/delete/",
          backend_url: "permission_category/*/.DELETE",
        },
        {
          key: "role",
          id: 115,
          name: "عرض كل الادوار",
          frontend_url: "roles/show-all",
          backend_url: "role/.GET",
        },
        {
          key: "role",
          id: 116,
          name: "اضافة دور",
          frontend_url: "roles/add",
          backend_url: "role/.POST",
        },
        {
          key: "role",
          id: 117,
          name: "تعديل دور",
          frontend_url: "roles/edit/",
          backend_url: "role/*/.PUT",
        },
        {
          key: "role",
          id: 118,
          name: "عرض دور",
          frontend_url: "roles/show/",
          backend_url: "role/*/.GET",
        },
        {
          key: "role",
          id: 119,
          name: "حذف دور",
          frontend_url: "roles/delete/",
          backend_url: "role/*/.DELETE",
        },
        {
          key: "admin",
          id: 120,
          name: "عرض كل المديرين",
          frontend_url: "admins/show-all",
          backend_url: "admin/.GET",
        },
        {
          key: "admin",
          id: 121,
          name: "اضافة مدير",
          frontend_url: "admins/add",
          backend_url: "admin/.POST",
        },
        {
          key: "admin",
          id: 122,
          name: "تعديل مدير",
          frontend_url: "admins/edit/",
          backend_url: "admin/*/.PUT",
        },
        {
          key: "admin",
          id: 123,
          name: "عرض مدير",
          frontend_url: "admins/show/",
          backend_url: "admin/*/.GET",
        },
        {
          key: "admin",
          id: 124,
          name: "حذف مدير",
          frontend_url: "admins/delete/",
          backend_url: "admin/*/.DELETE",
        },
        {
          key: "permission",
          id: 125,
          name: "عرض كل الصلاحيات",
          frontend_url: "permissions/show-all",
          backend_url: "permission/.GET",
        },
        {
          key: "permission",
          id: 126,
          name: "اضافة صلاحية",
          frontend_url: "permissions/add",
          backend_url: "permission/.POST",
        },
        {
          key: "permission",
          id: 127,
          name: "تعديل صلاحية",
          frontend_url: "permissions/edit/",
          backend_url: "permission/*/.PUT",
        },
        {
          key: "permission",
          id: 128,
          name: "عرض صلاحية",
          frontend_url: "permissions/show/",
          backend_url: "permission/*/.GET",
        },
        {
          key: "permission",
          id: 129,
          name: "حذف صلاحية",
          frontend_url: "permissions/delete/",
          backend_url: "permission/*/.DELETE",
        },
        {
          key: "meal_name",
          id: 140,
          name: "عرض كل اسم الوجبات",
          frontend_url: "meal_name/show-all",
          backend_url: "meal_name/.GET",
        },
        {
          key: "meal_name",
          id: 141,
          name: "اضافة اسم وجبة",
          frontend_url: "meal_name/add",
          backend_url: "meal_name/.POST",
        },
        {
          key: "meal_name",
          id: 142,
          name: "تعديل اسم وجبة",
          frontend_url: "meal_name/edit/",
          backend_url: "meal_name/*/.PUT",
        },
        {
          key: "meal_name",
          id: 143,
          name: "عرض اسم وجبة",
          frontend_url: "meal_name/show/",
          backend_url: "meal_name/*/.GET",
        },
        {
          key: "meal_name",
          id: 144,
          name: "حذف اسم وجبة",
          frontend_url: "meal_name/delete/",
          backend_url: "meal_name/*/.DELETE",
        },
        {
          key: "get_multi_google_meals",
          id: 130,
          name: "عرض كل وجبات المتاجر",
          frontend_url: "multi_google_meals/show-all",
          backend_url: "get_multi_google_meals/.GET",
        },
        {
          key: "get_multi_google_meals",
          id: 131,
          name: "اضافة وجبات للمتاجر",
          frontend_url: "multi_google_meals/add",
          backend_url: "get_multi_google_meals/.POST",
        },
        {
          key: "get_multi_google_meals",
          id: 132,
          name: "تعديل وجبات المتاجر",
          frontend_url: "multi_google_meals/edit/",
          backend_url: "get_multi_google_meals/*/.PUT",
        },
        {
          key: "get_multi_google_meals",
          id: 133,
          name: "عرض وجبات المتاجر",
          frontend_url: "multi_google_meals/show/",
          backend_url: "get_multi_google_meals/*/.GET",
        },
        {
          key: "get_multi_google_meals",
          id: 134,
          name: "حذف وجبات المتاجر",
          frontend_url: "multi_google_meals/delete/",
          backend_url: "get_multi_google_meals/*/.DELETE",
        },
        {
          key: "packages",
          id: 135,
          name: "عرض كل تصنيفات الطرود",
          frontend_url: "packages/show-all",
          backend_url: "packages/.GET",
        },
        {
          key: "packages",
          id: 136,
          name: "اضافة تصنيف",
          frontend_url: "packages/add",
          backend_url: "packages/.POST",
        },
        {
          key: "packages",
          id: 137,
          name: "تعديل تصنيف",
          frontend_url: "packages/edit/",
          backend_url: "packages/*/.PUT",
        },
        {
          key: "packages",
          id: 138,
          name: "عرض تصنيف",
          frontend_url: "packages/show/",
          backend_url: "packages/*/.GET",
        },
        {
          key: "packages",
          id: 139,
          name: "حذف تصنيف",
          frontend_url: "packages/delete/",
          backend_url: "packages/*/.DELETE",
        },
        {
          key: "plans",
          id: 145,
          name: "عرض كل خطط الاسعار",
          frontend_url: "plans/show-all",
          backend_url: "plans/.GET",
        },
        {
          key: "plans",
          id: 146,
          name: "اضافة خطة السعر",
          frontend_url: "plans/add",
          backend_url: "plans/.POST",
        },
        {
          key: "plans",
          id: 147,
          name: "تعديل خطة السعر",
          frontend_url: "plans/edit/",
          backend_url: "plans/*/.PUT",
        },
        {
          key: "plans",
          id: 148,
          name: "عرض خطة السعر",
          frontend_url: "plans/show/",
          backend_url: "plans/*/.GET",
        },
        {
          key: "plans",
          id: 149,
          name: "حذف خطة السعر",
          frontend_url: "plans/delete/",
          backend_url: "plans/*/.DELETE",
        },
        {
          key: "rewards",
          id: 150,
          name: "عرض كل الجوائز",
          frontend_url: "rewards/show-all",
          backend_url: "rewards/.GET",
        },
        {
          key: "rewards",
          id: 151,
          name: "اضافة جائزة",
          frontend_url: "rewards/add",
          backend_url: "rewards/.POST",
        },
        {
          key: "rewards",
          id: 152,
          name: "تعديل جائزة",
          frontend_url: "rewards/edit/",
          backend_url: "rewards/*/.PUT",
        },
        {
          key: "rewards",
          id: 153,
          name: "عرض جائزة",
          frontend_url: "rewards/show/",
          backend_url: "rewards/*/.GET",
        },
        {
          key: "rewards",
          id: 154,
          name: "حذف جائزة",
          frontend_url: "rewards/delete/",
          backend_url: "rewards/*/.DELETE",
        },
        {
          key: "user_rewards",
          id: 155,
          name: "عرض كل طلبات الجوائز",
          frontend_url: "user_rewards/show-all",
          backend_url: "user_rewards/.GET",
        },
        {
          key: "reports",
          id: 156,
          name: "المديونية",
          frontend_url: "debits_reports",
          backend_url: "report/indebtedness/.GET",
        },
        {
          key: "reports",
          id: 157,
          name: "حركة المحفظة",
          frontend_url: "wallet_reports",
          backend_url: "report/admin-transactions/.GET",
        },
        {
          key: "reports",
          id: 158,
          name: "الايداع",
          frontend_url: "deposit_reports",
          backend_url: "report/deposites/.GET",
        },
        {
          key: "reports",
          id: 159,
          name: "تقارير الطلبات",
          frontend_url: "order_reports",
          backend_url: "report/orders/.GET",
        },
        {
          key: "reports",
          id: 160,
          name: "الطلبات الملغاه",
          frontend_url: "cancel_order_reports",
          backend_url: "report/cancel-orders/.GET",
        },
        {
          key: "reports",
          id: 161,
          name: "الطلبات اليومية",
          frontend_url: "daily_orders_reports",
          backend_url: "report/daily-orders/.GET",
        },
      ],
    };
  },

  computed: {
    editMode() {
      return !!this.id;
    },
  },

  methods: {
    resetForm() {
      this.data.permission_category_id = null;
      this.data.permission_row = [
        {
          title_ar: null,
          title_en: null,
          icon: null,
          permission_route: null,
          is_side_show: true,
          is_control_permissions: true,
        },
      ];
    },
    deleteRow(index) {
      this.data.permission_row.splice(index, 1);
    },
    appendRow() {
      this.data.permission_row.push({
        title_ar: null,
        title_en: null,
        icon: null,
        permission_route: null,
        is_side_show: true,
        is_control_permissions: true,
      });
    },
    // Validate Data
    //validate Form
    validateCreateForm() {
      if (!this.data.permission_category_id) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أقسام الصلاحيات مطلوبة",
          position: "bottomRight",
        });
        return;
      }
      for (let row of this.data.permission_row) {
        if (!row.title_ar) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.title_ar"),
            position: "bottomRight",
          });
          return;
        }
        if (!row.title_en) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.title_en"),
            position: "bottomRight",
          });
          return;
        }
        if (!row.permission_route) {
          this.$iziToast.error({
            timeout: 2000,
            message: "رابط الصلاحية مطلوب",
            position: "bottomRight",
          });
          return;
        }
      }

      this.submitData();
    },
    // Submit Data
    submitData() {
      this.btnIsLoading = true;
      const frmData = new FormData();
      frmData.append(
        "permission_category_id",
        this.data.permission_category_id.id
      );

      if (this.id) {
        this.data.permission_row.map((row) => {
          frmData.append("_method", "PUT");
          frmData.append(`titles[0][ar][title]`, row.title_ar);
          frmData.append(`titles[0][en][title]`, row.title_en);
          if (row.icon) {
            frmData.append(`icons[0]`, row.icon);
          }
          frmData.append(
            `back_route_names[0]`,
            row.permission_route.backend_url
          );
          frmData.append(
            `front_route_names[0]`,
            row.permission_route.frontend_url
          );
          frmData.append(
            `is_control_permissions[0]`,
            +row.is_control_permissions
          );
          frmData.append(`show_in_side_bar[0]`, +row.is_side_show);
        });
      } else {
        this.data.permission_row.map((row, index) => {
          frmData.append(`titles[${index}][ar][title]`, row.title_ar);
          frmData.append(`titles[${index}][en][title]`, row.title_en);

          frmData.append(`icons[${index}]`, row.icon ? row.icon : "");
          frmData.append(
            `back_route_names[${index}]`,
            row.permission_route.backend_url
          );
          frmData.append(
            `front_route_names[${index}]`,
            row.permission_route.frontend_url
          );
          frmData.append(
            `is_control_permissions[${index}]`,
            +row.is_control_permissions
          );
          frmData.append(`show_in_side_bar[${index}]`, +row.is_side_show);
        });
      }
      let url = "";

      if (this.id) {
        url = `permission/${this.id}`;
      } else {
        url = "permission";
      }

      let message = this.id ? this.$t("editSuccess") : this.$t("addSuccess");

      this.$axios
        .post(url, frmData)
        .then(() => {
          this.$iziToast.success({
            title: this.$t("success"),
            message: message,
          });

          this.$router.push("/permissions/show-all");

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.btnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message ?? err.response.data.messages,
            position: "bottomRight",
          });
        });
    },
    getEditData() {
      this.noData = false;
      if (this.editMode) {
        this.loading = true;
        this.$axios({
          method: "GET",
          url: `permission/${this.id}`,
        })
          .then((res) => {
            this.loading = false;
            const result = res.data.data;

            this.data.permission_category_id = this.permission_categories.find(
              (el) => el.name == result.permission_category
            );

            this.data.permission_row = [
              {
                title_ar: result.ar.title,
                title_en: result.en.title,
                icon: result.icon,
                permission_route: this.allRoutes.find(
                  (el) => el.frontend_url == result.front_route_name
                ),
                is_side_show: result.show_in_side_bar,
                is_control_permissions: result.is_control_permission,
              },
            ];
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
            this.noData = true;

            this.loading = false;
          });
      }
    },
    getCategories() {
      this.loading = true;
      this.$axios
        .get("permission_category_not_paginated")
        .then((res) => {
          this.permission_categories = res.data.data.map((el) => ({
            id: el.id,
            name: el[this.$i18n.locale].name,
          }));
          if (this.id) {
            this.getEditData();
          } else {
            this.loading = false;
          }
        })
        .catch(() => (this.loading = false));
    },
  },

  mounted() {},
  async created() {
    this.control = this.$permission.setControls(this.$route.path);
    await this.getCategories();
  },
};
</script>
<style lang="scss">
.permissions_row {
  border: 1px solid var(--mainColor-2);
  border-radius: 10px;
  padding: 10px;
}
</style>
